import { createFileRoute } from '@tanstack/react-router';

interface FormAddSearch {
  id?: string;
}

export const Route = createFileRoute('/w/form/add')({
  staticData: { breadcrumb: 'Create Form', breadcrumbKey: 'K_BREADCRUMB_CREATE_FORM' },
  validateSearch: (search: Record<string, unknown>): FormAddSearch => ({
    id: typeof search.id === 'string' ? search.id : undefined,
  }),
});
